"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FiltersOption = exports.FiltersList = exports.FiltersButton = exports.Filters = exports.FilterManagement = exports.FilterHeader = exports.FilterContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledComponentsBreakpoint = _interopRequireDefault(require("styled-components-breakpoint"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var FilterContainer = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-bottom: 0.8rem;\n    margin-bottom: 0.8rem;\n    border-bottom: 1px solid #fff;\n\n    h4 {\n        margin-bottom: 0;\n    }\n\n    .filter-inputs {\n        height: 0px;\n        overflow: hidden;\n\n        &.filter-inputs--show {\n            height: auto;\n            overflow: visible;\n            margin-top: 1rem;\n        }\n    }\n"])));

exports.FilterContainer = FilterContainer;

var FilterHeader = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    cursor: pointer;\n    user-select: none;\n\n    h4 {\n        font-size: 1rem;\n        margin-bottom: 0;\n    }\n\n    .filter-count {\n        color: ", ";\n        font-size: 0.9rem;\n        font-weight: 300;\n    }\n"])), function (props) {
  return props.theme.admin.colors.brand;
});

exports.FilterHeader = FilterHeader;

var Filters = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    position: relative;\n"])));

exports.Filters = Filters;

var FiltersButton = _styledComponents["default"].button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    width: 90px;\n"])));

exports.FiltersButton = FiltersButton;

var FiltersList = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: calc(100% + 5px);\n    right: 0;\n    background-color: #ffffff;\n    min-width: 100%;\n    max-height: 300px;\n    overflow: auto;\n    padding: 5px;\n    box-shadow: 0 0 3px 0px #c5c5c5;\n    border-radius: 4px;\n    z-index: 10;\n    width: 180px;\n"])));

exports.FiltersList = FiltersList;

var FiltersOption = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    label {\n        cursor: pointer;\n        user-select: none;\n        width: 100%;\n    }\n\n    &:last-child {\n        label {\n            margin-bottom: 0;\n        }\n    }\n"])));

exports.FiltersOption = FiltersOption;

var FilterManagement = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: flex-end;\n    flex-wrap: wrap;\n    width: 100%;\n\n    ", ";\n"])), (0, _styledComponentsBreakpoint["default"])('laptop')(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n       width: auto;  \n    "]))));

exports.FilterManagement = FilterManagement;